module.exports = __webpack_public_path__ + "img/sc.bcd93e24.svg";